<template>
  <div>
    <Head title="Create Course" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link
        class="text-indigo-400 hover:text-indigo-600"
        :href="$routes.courses()"
      >
        Cursuri
      </Link>
      <span class="font-medium text-indigo-400">/</span> Create
    </h1>
    <div class="max-w-3xl overflow-hidden rounded-sm bg-white shadow-sm">
      <course-form v-model="form" @submit="form.post($routes.courses())">
        <div
          class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-8 py-4"
        >
          <loading-button
            :loading="form.processing"
            class="btn-teal"
            type="submit"
          >
            Create Course
          </loading-button>
        </div>
      </course-form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import CourseForm from './Form.vue';

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    CourseForm,
  },
  layout: Layout,
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        course: this.course,
      }),
    };
  },
};
</script>
